import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Common } from '../../Assets/styles/common';
import { Text } from 'ilenia';

interface ErrorProps {
    text?: string;
}

export const Error: React.SFC<ErrorProps> = (props) => {
    return (
        <div className={css(styles.box)}>
            <span className={css(styles.msg)}>
                {props.text ? <Text id={props.text}/> : ''}
            </span>
        </div>
    );
};

const styles = StyleSheet.create({
    box: {
        width: Common.Dimensions.controlWidth,
        minWidth: Common.Dimensions.minControlWidth,
        maxWidth: Common.Dimensions.maxControlWidth,
        height: '32px',
        borderRadius: '0px 0px 4px 4px',
        backgroundColor: '#fc4c5d',
        boxShadow: 'inset 0 1px 3px 0 rgba(252, 76, 93, 0.4)',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: '1.33',
        letterSpacing: 'normal',
        color: '#ffffff'
    },
    msg: {
        padding: '8px',
        lineHeight: '32px',
        verticalAlign: 'middle'
    }
});
